import { SortEnum, TeamsV2Query, TeamsV2QueryVariables } from '@/types/generated/graphql';
import { useState } from 'react';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { CURSOR_TEAMS_V2 } from '@/graphql/cursor.graphql';
import { Prettify } from '@/types/app.types';
import { UseTeamsReturn } from '../teams.types';

export function useTeams(): Prettify<UseTeamsReturn> {
  const [filter, setFilter] = useState({
    query: '',
    limit: 4,
    sort: SortEnum.DESC,
  });

  const { data, initialLoading, hasNextPage } = useCursorPagination<TeamsV2Query, TeamsV2QueryVariables>({
    schema: CURSOR_TEAMS_V2,
    responseDataKey: 'teamsV2',
    variables: filter,
  });

  return {
    data,
    setFilter,
    hasNextPage,
    initialLoading,
  };
}
